export const HomeTsProjTotalTransLength = 2.5;
export const HomeTsProjGridSnapTiming = 1.5;
export const HomeTsProjGridExpandTiming = 1;

export const gridDelay = 0.4;
export const gridTransTime = 1.1;
export const gridTransLength = 2.35;
export const girdTransTotalDuration = gridTransLength + gridDelay;